import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import catalog from "../locales/resources.json";
import campusCatalogs from "../locales/campusOverrides.json";
import CurrentCampusService from "../services/CurrentCampusService";
import {
  applyI18nCatalog,
  deepMerge,
  isLanguageCatalog
} from "./applyI18nCatalog";
import { bindI18nLocaleSync } from "./i18nLocaleSync";

const cloneBundle = bundle => JSON.parse(JSON.stringify(bundle));

const toResources = source => {
  const resources = {};
  Object.keys(source || {}).forEach(lng => {
    resources[lng] = { translation: cloneBundle(source[lng]) };
  });
  if (source["pt-BR"] && !resources.pt) {
    resources.pt = { translation: cloneBundle(source["pt-BR"]) };
  }
  return resources;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: toResources(catalog),
    fallbackLng: "pt-BR",
    supportedLngs: ["pt-BR", "pt", "en"],
    nonExplicitSupportedLngs: true,
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng"
    }
  });

let currentCampusId = CurrentCampusService.get();
let remoteOverrides = null;

const refreshCatalog = () => {
  const campusOverrides = campusCatalogs[String(currentCampusId)];
  applyI18nCatalog(
    isLanguageCatalog(campusOverrides)
      ? deepMerge(catalog, campusOverrides)
      : catalog,
    remoteOverrides
  );
};

refreshCatalog();
bindI18nLocaleSync();

export const applyRemoteI18nOverrides = overrides => {
  if (!isLanguageCatalog(overrides)) {
    return false;
  }
  remoteOverrides = overrides;
  refreshCatalog();
  return true;
};

export const applyCampusI18nOverrides = campusId => {
  currentCampusId = campusId;
  refreshCatalog();
};

export { applyI18nCatalog };
export default i18n;
